export interface Question {
  id: number;
  text: string;
  isAnswered: boolean;
  videoUrl?: string;
}

export const QUESTIONS: Question[] = [
  {
    id: 1,
    text: 'What motivates you?',
    isAnswered: false,
  },
  {
    id: 2,
    text: 'What professional achievement are you most proud of so far?',
    isAnswered: false,
  },
  {
    id: 3,
    text: 'What are you looking for in terms of career development?',
    isAnswered: false,
  },
];
